/**
 * What a detection run looks for. Chosen when the run starts and fixed for its whole life.
 *
 * Both kinds share the same polygon-drawing UI, endpoint and stages; chalk adds a colour
 * pick, returns polylines directly (no point cloud), and takes its width by hand.
 *
 * Only ever append members — the value is persisted with the execution.
 */
export enum DetectionKind {
  Crack,
  Chalk,
}

export enum CrackDetectionStage {
  None,
  Drawing,
  Preview,

  /** Request for crack detection has been sent */
  Requesting,

  /** Polling for crack detection result */
  Polling,

  /** Detection has completed, user is fine-tuning the polylines */
  FineTune,

  /** Saving polylines */
  SavingPolylines,

  /** Detection process failed */
  Failed,
}
